// extracted by mini-css-extract-plugin
export default {"authInput":"Auth_authInput__3I+no","hasError":"Auth_hasError__7Ayxk"};